var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload20 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 2.5c.46 0 .833.373.833.833v6.739l1.494-1.495a.833.833 0 1 1 1.179 1.179l-2.917 2.917a.833.833 0 0 1-1.178 0L6.494 9.756a.833.833 0 1 1 1.179-1.179l1.494 1.495V3.333c0-.46.373-.833.833-.833m-6.667 9.167c.46 0 .834.373.834.833v3.333h11.666V12.5a.833.833 0 0 1 1.667 0v4.167c0 .46-.373.833-.833.833H3.333a.833.833 0 0 1-.833-.833V12.5c0-.46.373-.833.833-.833",
  clipRule: "evenodd"
})));
export default SvgDownload20;